var typeaheadContainer = {
    base: {
        display: "flex",
        flexDirection: "column",
        gap: 2,
        "--list-option-padding": "10px 16px 10px 16px",
    },
};
var typeaheadInputContainer = {
    base: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        borderColor: "black.20",
        borderStyle: "solid",
        borderWidth: 1,
        borderRadius: 3,
        flex: 1,
        "&:focus-within": {
            boxShadow: 0,
            borderColor: "primary.100",
        },
    },
    variants: {
        error: {
            true: {
                borderColor: "critical.60",
            },
        },
        size: {
            sm: {
                paddingLeft: "8px",
                paddingRight: "8px",
            },
            md: {
                paddingLeft: "16px",
                paddingRight: "8px",
            },
            lg: {
                paddingLeft: "16px",
                paddingRight: "8px",
            },
        },
    },
};
var typeaheadInput = {
    base: {
        border: "none",
        boxSizing: "border-box",
        flex: 1,
        outline: "none",
        padding: 0,
        font: "body",
    },
    variants: {
        size: {
            sm: {
                padding: "6px 8px",
                height: "34px",
                font: "sm",
            },
            md: {
                padding: "10px 16px",
                height: "44px",
            },
            lg: {
                padding: "16px",
                height: "56px",
            },
        },
        isFocused: {
            true: {
                boxShadow: "0 0 0 4px #CCE0F6",
                borderColor: "primary.100",
            },
        },
    },
};
var typeaheadDropdown = {
    base: {
        border: "1px solid",
        borderColor: "black.20",
        borderRadius: 3,
        backgroundColor: "inherit",
        "& > ul": {
            borderRadius: 3,
            margin: 0,
            background: "white",
            listStyle: "none",
            paddingLeft: 0,
            paddingRight: 0,
            maxHeight: "500px",
            overflow: "auto",
            paddingTop: 1,
            paddingBottom: 1,
        },
    },
    variants: {
        size: {
            sm: {
                "--list-option-padding": "6px 8px 6px 16px",
                "--list-option-height": "33px",
            },
            md: {
                "--list-option-padding": "10px 16px 10px 16px",
                "--list-option-height": "44px",
            },
            lg: {
                "--list-option-padding": "16px 24px",
                "--list-option-height": "56px",
            },
        },
    },
};
var typeaheadPortal = {
    base: {
        bg: "white",
        "&[data-direction=up]": {
            marginTop: -2,
        },
        "&[data-direction=down]": {
            marginTop: 2,
        },
    },
};
var typeaheadSection = {
    base: {
        "& > ul": {
            margin: 0,
            background: "white",
            listStyle: "none",
            padding: 0,
        },
    },
};
var typeaheadSectionHeading = {
    base: {
        display: "flex",
        alignItems: "center",
        boxSizing: "border-box",
        height: "30px",
        font: "xs",
        padding: "var(--list-option-padding)",
    },
};
var typeaheadOption = {
    base: {
        fontFamily: "body",
        cursor: "pointer",
        boxSizing: "border-box",
        height: "var(--list-option-height)",
        padding: "var(--list-option-padding)",
    },
};

export { typeaheadContainer, typeaheadDropdown, typeaheadInput, typeaheadInputContainer, typeaheadOption, typeaheadPortal, typeaheadSection, typeaheadSectionHeading };
//# sourceMappingURL=typeahead.js.map
